import {AccountDTO} from "../../types";
import * as action_types from '../actions/actionTypes';

export type RegUserState = {
    loading_reguser_data: boolean;
    association_account: AccountDTO | null;
};

const initial_state: RegUserState = {
    loading_reguser_data: true,
    association_account: null
};

const set_loading_reguser_data = (state: RegUserState, action: any): RegUserState => {
    return {
        ...state,
        loading_reguser_data: action.loading_reguser_data
    }
};

const set_association_account = (state: RegUserState, action: any): RegUserState => ({
    ...state,
    association_account: action.association_account
});

const reducer = (state = initial_state, action: any) => {
    switch (action.type) {
        case action_types.REGUSER_SET_LOADING_REGUSER_DATA:
            return set_loading_reguser_data(state, action);
        case action_types.REGUSER_SET_ASSOCIATION_ACCOUNT:
            return set_association_account(state, action);
        default:
            return state;
    }
};

export default reducer;